import {
  FamilyNameTitle,
  FamilyNameInput,
  FamilyNameControl,
  FamilyNameContainer
} from './Overview.styles';

import { type ChangeEvent, useState, useEffect } from 'react';
import EditIcon from '@/assets/images/icons/edit.svg?component';
import PlusIcon from '@/assets/images/icons/plus.svg?component';
import CheckIcon from '@/assets/images/icons/icon-check.svg?component';

type FamilyNameProps = {
  onSubmit: (name: string) => void;
  onEditEnd?: () => void;
  onEdit?: () => void;
  name: string;
  isEditing: boolean;
};

export const FamilyName = ({
  name,
  onEdit,
  onSubmit,
  onEditEnd,
  isEditing
}: FamilyNameProps) => {
  const [edit, setEdit] = useState(false);
  const [currentName, setCurrentName] = useState(name);

  const onChange = (event: ChangeEvent<HTMLInputElement>) =>
    setCurrentName(event.target.value);

  const handleControll = () => {
    if (edit) return handleSubmit();

    setEdit(true);
    onEdit?.();
  };

  const handleSubmit = () => {
    onSubmit(currentName);
    setEdit(false);
    onEditEnd?.();
  };

  const onCloseEdit = () => {
    setCurrentName(name);
    setEdit(false);
    onEditEnd?.();
  };

  useEffect(() => {
    setCurrentName(name);
  }, [name]);

  useEffect(() => {
    setEdit(isEditing);
  }, [isEditing]);

  return (
    <FamilyNameContainer>
      {!edit ? (
        <FamilyNameTitle>{currentName}</FamilyNameTitle>
      ) : (
        <FamilyNameInput
          onChange={onChange}
          value={currentName}
          maxLength={30}
          autoFocus
        />
      )}

      <FamilyNameControl>
        {edit && (
          <PlusIcon
            style={{ transform: 'rotate(45deg)' }}
            onClick={onCloseEdit}
            height="25"
            width="25"
          />
        )}

        {(edit && (
          <CheckIcon onClick={handleControll} height="17" width="25" />
        )) || <EditIcon onClick={handleControll} />}
      </FamilyNameControl>
    </FamilyNameContainer>
  );
};
